function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVaporizer = function SvgVaporizer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    style: {
      fill: "#061e21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1 25.54c0 .54 1.97.98 4.4.98s4.4-.44 4.4-.98m-8.8 11.73c0 .54 1.97.98 4.4.98s4.4-.44 4.4-.98m-8.8-18.58a4.4 4.4 0 0 0 8.8 0m0-5.87v28.36c0 .54-1.97.98-4.4.98s-4.4-.44-4.4-.98V12.83h8.8Zm-2.44 20.53c0-1.08-1.96-3.91-1.96-3.91s-1.96 2.83-1.96 3.91.88 1.96 1.96 1.96 1.96-.88 1.96-1.96",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.33px"
    }
  }));
};
export default SvgVaporizer;